module.exports = __webpack_public_path__ + "static/media/portfolio_site_proteggere_venice_1-15.889ce9c8.png";